import React from "react";
import TemplateGCard from "@particles/card/templates/TemplateG/components/TemplateGCard";
import { TemplateProps } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

/**
 * This is the template G of cards. Used to display 10 articles in one column.
 * https://www.figma.com/design/rmzJoZwUpb3iLm6lMDXJ2W/BT-MASTER--WEB-?node-id=1209-15028&m=dev
 */
const TemplateG = ({
  className,
  cardProps,
  cardVariantOverride,
  lang = "en",
}: TemplateProps): React.ReactElement => {
  return (
    <div
      data-testid="card-template-component"
      data-template="template-g"
      className={cn("stories grid grid-cols-1 gap-8", className)}
    >
      {cardProps.map((cardProp, index) => (
        <TemplateGCard
          key={cardProp.id}
          cardProp={cardProp}
          index={index}
          cardVariantOverride={cardVariantOverride}
          lang={lang}
        />
      ))}
    </div>
  );
};

export default TemplateG;
